import { render } from "./pediatrics_prescriptions.vue?vue&type=template&id=2d5cc9c0&scoped=true"
import script from "./pediatrics_prescriptions.vue?vue&type=script&lang=js"
export * from "./pediatrics_prescriptions.vue?vue&type=script&lang=js"

import "./pediatrics_prescriptions.vue?vue&type=style&index=0&id=2d5cc9c0&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5cc9c0"]])

export default __exports__